import { render, staticRenderFns } from "./ModelTreeVulkan.vue?vue&type=template&id=3dbf53b6&scoped=true"
import script from "./ModelTreeVulkan.vue?vue&type=script&lang=js"
export * from "./ModelTreeVulkan.vue?vue&type=script&lang=js"
import style0 from "./ModelTreeVulkan.vue?vue&type=style&index=0&id=3dbf53b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf53b6",
  null
  
)

export default component.exports